import { render, staticRenderFns } from "./SectionRequirementHeading.vue?vue&type=template&id=175d7de3&scoped=true"
import script from "./SectionRequirementHeading.vue?vue&type=script&lang=ts"
export * from "./SectionRequirementHeading.vue?vue&type=script&lang=ts"
import style0 from "./SectionRequirementHeading.vue?vue&type=style&index=0&id=175d7de3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175d7de3",
  null
  
)

export default component.exports